import WPStagingCommon from './../wpstg.js';

/**
 * Loader Modal
 */
export default class WpstgLoader {
  constructor(
      wpstgObject = wpstg,
  ) {
    this.wpstgObject = wpstgObject;
  }

  /**
   * Show Swal alert with loader and send ajax request to fetch content of alert.
   * @return Promise
   */
  showModal() {
    const swalPromise = this.loadModal();
    return swalPromise;
  }

  loadModal() {
    return WPStagingCommon.getSwalModal(false, {
      container: 'wpstg-swal2-container wpstg-swal2-loading wpstg-swal2-loading-sm',
    }).fire({
      title: '',
      icon: 'warning',
      html: this.getAjaxLoader(),
      width: '100px',
      focusConfirm: false,
      showConfirmButton: false,
      showCancelButton: false,
    });
  }

  getAjaxLoader() {
    return '<div class="wpstg-swal2-ajax-loader"><img src="' + this.wpstgObject.wpstgIcon + '" /></div>';
  }
}
